
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/rating",
      function () {
        return require("private-next-pages/mendable-api/rating.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/rating"])
      });
    }
  